export default __webpack_public_path__ + "static/media/yeezy1.82834953.png";